import React, { useEffect, useRef } from 'react'

import config from '../../config/config'
import { getLevel, calculateZoom } from '../../utils/utils'

const GoogleMap = ({ poi }) => {
  const mapRef = useRef(null)

  useEffect(() => {
    if (!poi) {
      return
    }

    const loadGoogleMapsScript = () => {
      const script = document.createElement('script')
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
      script.async = true
      script.defer = true
      script.onload = loadMap
      document.head.appendChild(script)
    }

    const loadMap = () => {
      if (!window.google) {
        console.warn("Google Maps API n'est pas chargé.")
        return
      }

      const mapOptions = {
        zoom: poi.gpxDatas
          ? calculateZoom(poi.gpsxMax, poi.gpsxMin, poi.gpsyMax, poi.gpsyMin)
          : config.mapPoiZoom,
        mapTypeId: 'terrain',
        styles: [
          {
            featureType: 'all',
            elementType: 'labels',
            stylers: [{ visibility: 'on' }],
          },
          {
            featureType: 'landscape.natural',
            elementType: 'geometry',
            stylers: [{ visibility: 'simplified' }, { color: '#7FBF7F' }],
          },
        ],
      }

      if (poi.gpxDatas && poi.gpxDatas.length > 0) {
        mapOptions.center = {
          lat: (poi.gpsxMax + poi.gpsxMin) / 2,
          lng: (poi.gpsyMax + poi.gpsyMin) / 2,
        }
      } else {
        mapOptions.center = { lat: poi.gpsx, lng: poi.gpsy }
      }

      const determineStrokeColor = (poi) => {
        const level = getLevel(poi)
        switch (level) {
          case 'BLUE':
            return 'blue'
          case 'GREEN':
            return 'yellow'
          case 'BLACK':
            return 'black'
          case 'RED':
            return 'red'
          default:
            return 'grey'
        }
      }

      const map = new window.google.maps.Map(mapRef.current, mapOptions)

      const markerIcon = `/images/markers/marker_50_${poi.poiType.name}.png`
      new window.google.maps.Marker({
        position: { lat: poi.gpsx, lng: poi.gpsy },
        map: map,
        title: poi.name,
        icon: markerIcon,
      })

      if (poi.gpxDatas && poi.gpxDatas.length > 0) {
        const path = poi.gpxDatas.map((point) => ({
          lat: point[0],
          lng: point[1],
        }))

        const polyline = new window.google.maps.Polyline({
          path: path,
          geodesic: true,
          strokeColor: determineStrokeColor(poi),
          strokeOpacity: 1.0,
          strokeWeight: 2,
        })

        polyline.setMap(map)
      }
    }

    if (!window.google) {
      loadGoogleMapsScript()
    } else {
      loadMap()
    }
  }, [poi])

  return (
    <div>
      <div ref={mapRef} style={{ height: '500px', width: '100%' }}></div>
    </div>
  )
}

export default GoogleMap
